import api from './api';

export const tenantService = {
  // Dohvati sve tenante
  getAllTenants: async (query) => {
    const queryString = new URLSearchParams(query).toString();
    return await api.get(`/tenants?${queryString}`);
  },

  // Dohvati tenant po ID-u
  getTenantById: async (id) => {
    return await api.get(`/tenants/${id}`);
  },

  // Kreiraj novi tenant
  createTenant: async (tenantData) => {
    return await api.post('/tenants', tenantData);
  },

  // Ažuriraj tenant
  updateTenant: async (id, tenantData) => {
    return await api.put(`/tenants/${id}`, tenantData);
  },

  // Obriši tenant
  deleteTenant: async (id) => {
    return await api.delete(`/tenants/${id}`);
  },

  // Dohvati tenante po gradu
  getTenantsByCity: async (city) => {
    return await api.get(`/tenants/city/${city}`);
  },

  // Dohvati tenante po tipu posla
  getTenantsByBusinessType: async (businessType) => {
    return await api.get(`/tenants/business-type/${businessType}`);
  },

  // Ažuriraj subscription
  updateSubscription: async (id, subscriptionData) => {
    return await api.patch(`/tenants/${id}/subscription`, subscriptionData);
  },

  getExternalRegistrationInfo: async (subdomain) => {
    return await api.get(`/tenants/external-registration/${subdomain}`);
  },

  getTenantsByFilter: async (query) =>{
    const queryString = new URLSearchParams(query).toString();
    return await api.get(`/tenants/getTenantsByFilter?${queryString}`);
  },

  getTenantName: async (id) => {
    const queryString = new URLSearchParams({tenantId: id}).toString();
    return await api.get(`/tenants/name?${queryString}`);
  },

  // Upload loga za tenant
  uploadLogo: async (file) => {
    const formData = new FormData();
    formData.append('image', file);
    
    const token = localStorage.getItem('token');
    
    const response = await fetch(`${api.baseURL}/tenants/upload-image`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });
    
    if (!response.ok) {
      throw new Error(`Upload failed with status: ${response.status}`);
    }
    
    return await response.json();
  }

};

export default tenantService;


